module.exports = __webpack_public_path__ + "img/alien.ea91ac34.gif";